import React, { useEffect, useRef, useState } from 'react';
import { X, ChevronLeft, ChevronRight } from 'lucide-react';
import './MobilePhotoViewer.css';

const MobilePhotoViewer = ({ photos, currentIndex, onClose, onNavigate }) => {
  const [currentPhoto, setCurrentPhoto] = useState(photos[currentIndex]);
  const viewerRef = useRef(null);

  useEffect(() => {
    setCurrentPhoto(photos[currentIndex]);
  }, [currentIndex, photos]);

  useEffect(() => {
    // Force scroll to top when viewer opens
    window.scrollTo(0, 0);
    
    // Lock body scroll completely
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100vh';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';

    // Cleanup on unmount
    return () => {
      document.body.style.overflow = '';
      document.body.style.height = '';
      document.body.style.position = '';
      document.body.style.width = '';
    };
  }, []);

  const handlePrevious = () => {
    const newIndex = currentIndex > 0 ? currentIndex - 1 : photos.length - 1;
    onNavigate(newIndex);
  };

  const handleNext = () => {
    const newIndex = currentIndex < photos.length - 1 ? currentIndex + 1 : 0;
    onNavigate(newIndex);
  };

  const isVideo = currentPhoto?.content_type?.startsWith('video/');

  return (
    <div className="mobile-photo-viewer" ref={viewerRef}>
      {/* Close button */}
      <button className="mobile-viewer-close" onClick={onClose}>
        <X size={24} />
      </button>
      
      {/* Navigation */}
      {photos.length > 1 && (
        <>
          <button className="mobile-viewer-nav mobile-viewer-prev" onClick={handlePrevious}>
            <ChevronLeft size={28} />
          </button>
          <button className="mobile-viewer-nav mobile-viewer-next" onClick={handleNext}>
            <ChevronRight size={28} />
          </button>
        </>
      )}
      
      {/* Photo/Video - centered in viewport */}
      <div className="mobile-viewer-photo-container">
        {isVideo ? (
          <video 
            src={`${process.env.REACT_APP_API_URL || window.location.origin}/api/photos/${currentPhoto.id}/view`}
            className="mobile-viewer-media"
            controls
            playsInline
          />
        ) : (
          <img 
            src={`${process.env.REACT_APP_API_URL || window.location.origin}/api/photos/${currentPhoto.id}/view`}
            alt={currentPhoto.original_name}
            className="mobile-viewer-media"
            draggable={false}
          />
        )}
      </div>
      
      {/* Photo info */}
      <div className="mobile-viewer-info">
        <span className="mobile-viewer-counter">
          {currentIndex + 1} / {photos.length}
        </span>
        <span className="mobile-viewer-title">
          {currentPhoto.original_name}
        </span>
      </div>
    </div>
  );
};

export default MobilePhotoViewer;